import React from "react";
import ReactDOM from "react-dom/client";
import "../index.css";
import "../styles/tailwind.css";
import reportWebVitals from "../reportWebVitals";
import { Download } from "../pages/download";
import SetFavicon from "../components/SetFavicon"

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <SetFavicon />
    <Download />
  </React.StrictMode>
);
reportWebVitals();

